import './KeywordDensity.scss';
import IconX from './IconX.js';
import IconCheck from './IconCheck.js';
import TextUtils from "../lib/TextUtils.js";
import Markup from "../lib/Markup.js";

const KeywordDensity = function (props) {
	var {content, keyword, optimal} = props.pageContent;
	var {minKeywordDensity, maxKeywordDensity} = props.appSettings;
	minKeywordDensity = parseFloat(minKeywordDensity) || 0.5;
	maxKeywordDensity = parseFloat(maxKeywordDensity) || 3;

	var density = 0;
	if (keyword) {
		content = content.replaceAll('</', ' </');
		let text = Markup.stripTags(content);
		text = text.toLowerCase();

		var words = text.split(' ');
		words = words.filter((el) => {
			return el !== '';
		});

		var keywordCount = TextUtils.countOccurrences(keyword, text);

		if (keywordCount) {
			density = keywordCount / words.length * 100;
			density = density.toFixed(2);
		}
	}

	let optimalKeywordDensityMarkup = '';
	let icon = (<IconX />);
	if (minKeywordDensity && maxKeywordDensity) {
		let classes = 'check-list-item check optimal-keyword-density';
		let optimalKD = density >= minKeywordDensity && density <= maxKeywordDensity;

		classes += optimalKD ? ' ok' : ' nok';
		if (optimalKD) {
			icon = (<IconCheck />);
		}
		let optimalValue = (minKeywordDensity && maxKeywordDensity) ? `${minKeywordDensity}% - ${maxKeywordDensity}%` : `${optimal.optimalKeywordDensity}%`;
		optimalKeywordDensityMarkup = (<p className={classes}>{icon}{window?.t?.OPTIMAL_KEYWORD_DENSITY} <b className="value">{optimalValue}</b></p>);
	}

	return (
		<>
		<p className="keyword-density info no-icon">{window?.t?.KEYWORD_DENSITY}: <b className="value">{density}%</b></p>
		{optimalKeywordDensityMarkup}
		</>
	);
}

export default KeywordDensity;